export default "__VITE_ASSET__C4Na5lSl__"